<template>
    <div class="container">
        <!-- apiKey -->
        <div>
            <h1>ApiKey</h1>
            <div class="apikey-area">
                <template v-if="!apiKey">
                    <div class="empty-apikey">
                        <el-button @click="openBindApiKeyWindow">绑定已有apikey</el-button>
                        <el-button @click="openGeneralApiKeyWindow">生成apikey</el-button>
                    </div>
                </template>
                <template v-else style="display:flex-start;">
                    <div class="apikey">
                        <!-- <span>你的ApiKey:</span> -->
                        <el-input class="apikey-input" :value="apiKeyVisible" readonly>
                            <el-button slot="append" icon="el-icon-document-copy" @click.native="copyApiKey"></el-button>
                            <!-- <i class="el-icon-refresh"></i> -->
                        </el-input>
                        <el-button class="apikey-refresh" icon="el-icon-refresh" @click="openGeneralApiKeyWindow"></el-button>


                    </div>
                    <!-- <el-button @click="openBindApiKeyWindow">绑定已有apikey</el-button> -->
                    <!-- <el-button type="primary" @click="goToChat">前往第三方站点</el-button> -->
                    <!-- <i class="el-icon-question"></i> -->
                    <!-- <el-tooltip effect="dark"
                        content="点击该按钮将会携带apikey跳转到【AI对话】页面，页面会自动填写apikey并保存到浏览器缓存中，可以直接进行对话。请在私人设备中点击，避免apikey泄露。"
                        placement="top">
                        <i class="el-icon-question"></i>
                    </el-tooltip> -->
                </template>
            </div>
        </div>

        <!-- 套装使用情况 -->
        <div class="user-plan-info">
            <h1>套餐使用情况</h1>
            <div v-if="userPlans.length < 1">
                <div style="margin: 10px 0;">
                    <span>当前无任何可用的套餐</span>
                    <!-- ，请购买套餐后再使用ApiKey -->
                </div>
                <!-- <el-button type="primary" @click="redirectToPlans">购买套餐</el-button> -->
            </div>
            <div v-for="(plan, index) in userPlans" :key="index" class="plan-detail">
                <!-- 套餐标题 -->
                <div class="plan-title">
                    {{ plan.name }}
                    <!-- <span class="purple-btn" @click="redirectToRenew(plan.plan_id)">续费</span> -->
                </div>

                <div class="plan-content">
                    <!-- 流量信息 -->
                    <div class="quota-info">
                        <div class="quota-usage quota-info-line">
                            <div class="quota-label">已用额度</div>
                            <div class="number">{{ calNum(plan.flow_quota) - calNum(plan.balance) }} 万字</div>
                        </div>
                        <div class="quota-remain quota-info-line">
                            <div class="quota-label">剩余额度</div>
                            <div class="number">{{ calNum(plan.balance) }} 万字</div>
                        </div>
                        <div class="quota-total quota-info-line">
                            <div class="quota-label">套餐总量</div>
                            <div class="number">{{ calNum(plan.flow_quota) }} 万字</div>
                        </div>
                    </div>

                    <!-- 套餐过期信息 -->
                    <div class="plan-expire">
                        <div class="plan-reset quota-info-line">
                            <div class="plan-label">重置流量</div>
                            <div class="number">{{ calculateDay(plan.next_settle_time) }}天后</div>
                        </div>
                        <div class="plan-expire-date quota-info-line">
                            <div class="plan-label">套餐到期</div>
                            <div class="number">{{ calculateDay(plan.expire) }}天后</div>
                        </div>
                    </div>

                    <!-- 流量环形进度条 -->
                    <div class="progress-bar">
                        <el-progress type="circle" :percentage="calPercent(plan)" :color="colors"></el-progress>
                        <div class="progress-info"> 额度信息 </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>
  
<script>
import { ChatUserAPI } from '../api/user'
import { AccountAPI } from '../api/account'


export default {
    data() {
        return {
            apiKey: "", // apiKey内容，为空代表未绑定
            bindApiKeyDialogVisible: false, // 绑定apikey对话框的显示状态
            newApiKey: "", // 新的apikey输入框内容
            userPlans: [
                {
                    plan_id: 1,
                    plan_name: '基础套餐',
                    flow_type: '不限流量',
                    used_quota: 30000,
                    remain_quota: 500000,
                    total_quota: 550000,
                    next_settle_date: 5,
                    expire_date: 20
                },
                {
                    plan_id: 2,
                    plan_name: '高级套餐',
                    flow_type: '5G流量',
                    used_quota: 15000,
                    remain_quota: 85000,
                    total_quota: 100000,
                    next_settle_date: 8,
                    expire_date: 30
                }
            ],
            colors: [
                { color: '#5cb87a', percentage: 50 },
                { color: '#e6a23c', percentage: 80 },
                { color: '#f56c6c', percentage: 100 }
            ]
        }
    },
    methods: {
        // ApiKey相关方法
        queryApiKey() {
            ChatUserAPI.info().then(resp => {
                this.apiKey = resp.apikey
            })
        },
        // 弹出 生成ApiKey确认弹窗
        openGeneralApiKeyWindow() {
            this.$confirm('此操作会覆盖你已有的ApiKey, 是否继续？', '重置ApiKey', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                AccountAPI.refreshApiKey().then(resp => {
                    ChatUserAPI.info().then(resp => {
                        this.apiKey = resp.apikey
                        this.$message.success("生成ApiKey成功！")
                    })
                })
            })

        },
        // 弹出 绑定ApiKey弹窗
        openBindApiKeyWindow() {
            this.$prompt('', '绑定ApiKey', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                inputPattern: /^text.{44}$/,
                inputErrorMessage: 'ApiKey格式不正确',
                inputPlaceholder: '请输入要绑定的apikey'
            }).then(({ value }) => {
                AccountAPI.bindApiKey(value).then(resp => {
                    this.$message.success("绑定ApiKey成功!")
                    this.apiKey = value;
                    setTimeout(() => {
                        this.queryPlanInfos()
                    }, 1000);
                })
            });
        },

        copyApiKey() {
            // 复制apiKey到剪切板
            if (this.apiKey) {
                const input = document.createElement("input");
                input.setAttribute("readonly", "readonly");
                input.setAttribute("value", this.apiKey);
                document.body.appendChild(input);
                input.select();
                input.setSelectionRange(0, 99999); // 兼容ios
                document.execCommand("copy");
                document.body.removeChild(input);
                this.$message.success("apikey已复制到剪切板");
            }
        },
        goToChat() {
            // 前往【AI对话】页面
            if (this.apiKey) {
                this.$confirm('即将跳转到外部站点，是否确认跳转?', '提示', {
                confirmButtonText: '跳转',
                cancelButtonText: '取消',
                type: 'warning'
                }).then(() => {
                    const url = `http://smarttxt.cn/chat/index.html?apikey=${this.apiKey}`;
                    window.open(url);  
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消跳转'
                    });          
                });
            } else {
                this.$message.error("请先绑定apikey");
            }
        },



        // 套餐相关方法
        queryPlanInfos() {
            AccountAPI.queryPlanInfos().then(resp => {
                this.userPlans = resp
            })
        },
        calNum(num) {
            // 除以10000取整
            return Math.round(num / 10000);
        },
        calPercent(plan) {
            // 额度使用百分数
            const percentage = (this.calNum(plan.flow_quota) - this.calNum(plan.balance)) / this.calNum(plan.flow_quota) * 100
            return percentage ? Math.floor(percentage) : 0
        },
        redirectToPlans() {
            this.$router.push('/plans')
        },
        redirectToRenew(planId) {
            // 跳转到续费页面
            // this.router.push(`/plan/${planId}/renew`)
            this.todoMsg()
        },
        // 计算还有多少天
        calculateDay(date) {
            // 将传入的日期转换为时间戳毫秒数
            const passedDate = new Date(date).getTime();

            // 获取今天的日期时间戳毫秒数和单位为一天的毫秒数
            const today = new Date();
            const todayInMilliseconds = new Date(today.getFullYear(), today.getMonth(), today.getDate()).getTime();
            const dayInMilliseconds = 24 * 60 * 60 * 1000;

            // 使用 Math.floor() 函数向下取整计算日期之间的天数
            const days = Math.floor((passedDate - todayInMilliseconds) / dayInMilliseconds);

            // 返回计算出的天数
            return days;
        },
        todoMsg() {
            this.$message.info("功能近期即将上线，敬请期待！")
        }
    },
    computed: {
        apiKeyVisible() {
            // 转换后的apiKey显示文本，将apiKey的前4个字符和后4个字符显示出来中间用"..."代替
            return this.apiKey ? this.apiKey.slice(0, 6) + "......" + this.apiKey.slice(-6) : "";
        },
        isLogin() {
            return this.$store.state.isLogin
        },
        userInfo() {
            return this.$store.state.userInfo
        }
    },
    created() {
        if (!this.isLogin) {
            this.$message.warning("请先登录！")
            this.$router.replace("/")
            return
        }
        ChatUserAPI.info().then(resp => {
            this.apiKey = resp.apikey
            this.queryPlanInfos();
        })
    },
    mounted() {
    }
}
</script>
  
<style scoped>
.apikey-area {
    margin-top: 20px;
    margin-bottom: 30px;
    /* display: flex; */
    /* flex-direction: column; */
}

.empty-apikey {
    display: flex;
    /* justify-content: space-between; */
}

.apikey {
    margin-bottom: 20px;
    display: flex;
}

.apikey-input {
    flex: 1;
    max-width: 800px;
}

.apikey-refresh{
    /* flex: 1; */
    margin: 0 10px;
}

.container {
    font-size: 14px;
    color: #333;
    background-color: #fff;
    padding: 10px;
    overflow-x: hidden;
}

.copy-icon {
    margin: 0 10px;
}

.goto-chat {
    cursor: pointer;
    text-decoration: underline;
}

.question-mark {
    cursor: help;
    margin-left: 5px;
}

.user-plan-info {
    display: flex;
    flex-direction: column;
}

.plan-detail {
    display: flex;
    flex-direction: column;
    border: 1px solid #ddd;
    padding: 10px;
    margin-bottom: 10px;
    border-radius: 4px;
}

.plan-title {
    font-size: 16px;
    font-weight: bold;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.purple-btn {
    cursor: pointer;
    font-size: 14px;
    padding: 5px 10px;
    border: 1px solid #639;
    color: #639;
    border-radius: 4px;
}

.purple-btn:hover {
    background-color: #639;
    color: #fff;
}

.plan-content {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
}

.progress-bar {
    width: 33%;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.progress-circle {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 80px;
    height: 80px;
    border-radius: 50%;
    border: 1px solid #ddd;
    margin-bottom: 10px;
}

.progress-circle .progress-value {
    font-size: 20px;
    font-weight: bold;
}

.progress-info {
    font-size: 14px;
    color: gray;
}

.quota-info {
    width: 33%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

}

.quota-info .quota-usage,
.quota-info .quota-remain,
.quota-info .quota-total {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;

}

.quota-info-line {
    width: 160px;
}

.quota-info .quota-label {
    font-size: 14px;
    color: gray;
}

.quota-info .number {
    font-size: 16px;
    font-weight: bold;
}

.plan-expire {
    width: 33%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.plan-reset {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-bottom: 10px;
}

.plan-expire-date {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
}

.plan-label {
    font-size: 14px;
    color: gray;
    margin-right: 10px;
}

.number {
    font-size: 16px;
    font-weight: bold;
}

@media (max-width: 768px) {
    .plan-content {
        flex-direction: column;
        align-items: flex-start;
    }

    .progress-bar,
    .quota-info,
    .plan-expire {
        width: 100%;
        margin-bottom: 10px;
    }
}
</style>
  
  


// WEBPACK FOOTER //
// src/components/Account.vue